import { render, staticRenderFns } from "./ModalAddDocumentType.vue?vue&type=template&id=191145a8"
import script from "./ModalAddDocumentType.vue?vue&type=script&lang=js"
export * from "./ModalAddDocumentType.vue?vue&type=script&lang=js"
import style0 from "./ModalAddDocumentType.vue?vue&type=style&index=0&id=191145a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports